export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7282.8bbb96f8.jpg";